module.exports = __webpack_public_path__ + "files/SPIADI2026 - RÉA EXPL AUR - Fiche Service.2cd5ba0a5c63c5faf1c80e97c8bd6bd5.pdf";